/* eslint-disable @typescript-eslint/no-explicit-any */
import dynamic from 'next/dynamic';
import BottomSpacingSchema from '@amplience/content-types/src/content-schemas/c-bottom-spacing.json';
import HygienePageNavigationLinkSchema from '@amplience/content-types/src/content-schemas/c-hygiene-page-navigation-links.json';
import HygienePageRichTextSchema from '@amplience/content-types/src/content-schemas/c-hygiene-page-rich-text.json';
import IconAndCTASchema from '@amplience/content-types/src/content-schemas/c-icon-&-cta.json';
import OtherSimilarLinksSchema from '@amplience/content-types/src/content-schemas/c-other-similar-links.json';
import SimpleAccordionsSchema from '@amplience/content-types/src/content-schemas/c-simple-accordions.json';
import TwoColumnAccordionsSchema from '@amplience/content-types/src/content-schemas/c-two-column-accordions.json';

/* eslint-disable promise/prefer-await-to-then */
const Spacer = dynamic(() => import('@storefront/lib-global/globalComponents/spacer/Spacer').then((mod) => mod.Spacer));
const HygienePageNavigationLinks = dynamic(() =>
  import('./HygienePageNavigationLinks').then((mod) => mod.HygienePageNavigationLinks),
);
const HygienePageRichText = dynamic(() => import('./HygienePageRichText').then((mod) => mod.HygienePageRichText));
const IconAndCta = dynamic(() => import('./IconAndCta').then((mod) => mod.IconAndCta));
const OtherSimilarLinks = dynamic(() => import('./OtherSimilarLinks').then((mod) => mod.OtherSimilarLinks));
const SimpleAccordions = dynamic(() =>
  import('@storefront/lib-global/globalComponents/simpleAccordions/SimpleAccordions').then(
    (mod) => mod.SimpleAccordions,
  ),
);
const TwoColumnAccordions = dynamic(() => import('../twoColumnAccordions').then((mod) => mod.TwoColumnAccordions));
/* eslint-enable promise/prefer-await-to-then */

export function createHygienePageAmplienceComponents<T extends unknown[]>(array: T): any {
  const components: any = {};
  array?.forEach((comp) => {
    const componentProps = comp as any;

    if (!componentProps?._meta) {
      return;
    }

    if (componentProps._meta.schema === BottomSpacingSchema.$id) {
      components[BottomSpacingSchema.$id] = Spacer;
    } else if (componentProps._meta.schema === HygienePageNavigationLinkSchema.$id) {
      components[HygienePageNavigationLinkSchema.$id] = HygienePageNavigationLinks;
    } else if (componentProps._meta.schema === HygienePageRichTextSchema.$id) {
      components[HygienePageRichTextSchema.$id] = HygienePageRichText;
    } else if (componentProps._meta.schema === IconAndCTASchema.$id) {
      components[IconAndCTASchema.$id] = IconAndCta;
    } else if (componentProps._meta.schema === OtherSimilarLinksSchema.$id) {
      components[OtherSimilarLinksSchema.$id] = OtherSimilarLinks;
    } else if (componentProps._meta.schema === SimpleAccordionsSchema.$id) {
      components[SimpleAccordionsSchema.$id] = SimpleAccordions;
    } else if (componentProps._meta.schema === TwoColumnAccordionsSchema.$id) {
      components[TwoColumnAccordionsSchema.$id] = TwoColumnAccordions;
    }
  });

  return components;
}
